module.exports = __webpack_public_path__ + "static/media/AgriBio.c6123824.jpg";